<template>

    <div class="namad_window mt-4 " v-if="status === 'successNamadDetails'">
        <kt-row class=" mb-3" >
            <img class="center_namad" :src="getLogoImage()" alt="logo-image" style="max-width:150px; max-height:150px">
        </kt-row>
        <kt-panel>
            <kt-panel-body>
                <div v-if="status === 'successNamadDetails'">
                    <kt-row >
                        <img class="center_namad " :src="getShopLogo()" alt="shop" style="max-width:100px; max-height:100px">
                    </kt-row>
                    <kt-row class="mt-4  ">
                        <h5 class="d-inline-block center_namad">
                            {{namadGatewayDetails.shop_name}}
                        </h5>
                    </kt-row>
                    <kt-row class="mt-4 certified offset-2">
                        <span class="d-inline-block ml-1">
                            <i class="fa fa-check-circle "></i>
                            {{$t('namad.active_merchant')}}
                        </span>
                    </kt-row>
                    <kt-row class="mt-4 ">
                        <kt-col lg="12" md="12" xs="12">
                            <h5 class="form-group text-justify ml-4">
                                {{ $t('namad.merchant_profile') }}
                            </h5>
                        </kt-col>
                        <kt-col lg="12" md="12" xs="12">
                            <form id="userDetails" class="text-justify">
                                <ul>
                                    <li class="mb-3">
                                    <span class="d-inline-block" v-if="namadGatewayDetails.merchant_type == merchant_type.REAL">
                                        {{$t('namad.fullname')}} {{' : '}} {{namadGatewayDetails.fullname}}
                                    </span>
                                    <span class="d-inline-block" v-else-if="namadGatewayDetails.merchant_type == merchant_type.LEGAL">
                                        {{$t('namad.com_name_fa')}} {{' : '}} {{namadGatewayDetails.fullname}}
                                    </span>
                                    </li>

                                    <li class="mb-3">
                                    <span class="d-inline-block">
                                        {{$t('namad.register_date')}} {{' : '}} {{namadGatewayDetails.register_date}}
                                    </span>
                                    </li>

                                    <li class="mb-3">
                                    <span class="d-inline-block">
                                        {{$t('namad.address')}} {{' : '}} {{namadGatewayDetails.address}}
                                    </span>
                                    </li>
                                </ul>
                            </form>
                        </kt-col>
                    </kt-row>
                    <kt-row class="mt-2">
                        <a :href="getNamadReportUrl()" target="_blank" class="center_namad">
                            <button class="btn btn-info btn-wide"
                            >{{ $t('namad.report') }}
                            </button>
                        </a>
                    </kt-row>
                </div>

<!--                <div class="line-divider mt-3 mb-1"></div>-->

                <kt-row v-if="status === 'namad_error'" class="center_namad"></kt-row>
            </kt-panel-body>
        </kt-panel>
    </div>



</template>

<script>
import { merchantType } from '@/constants/merchantType';
import { mapGetters } from "vuex";


export default {
    data() {
        return {
            merchant_type: merchantType,
        }
    },
    computed: {
        ...mapGetters('gateway', [
            'namadGatewayDetails', 'status', 'namad_error'
        ])
    },
    methods: {
        getLogoImage() {
            return this.namadGatewayDetails.site_logo
        },
        getShopLogo() {
            if (this.status === 'successNamadDetails') {
                return this.namadGatewayDetails.shop_logo
            }
        },
        getNamadReportUrl(){
            return this.namadGatewayDetails.report_url;
        }
    },

    mounted() {
        this.$store.dispatch('gateway/fetchNamad', this.$route.params.gateway_id)
    }
}

</script>

<style>
    .namad_window {
        text-align: center;
        margin: 0 auto;
        max-width: 700px;
        max-height: 50%;
    }
    .center_namad {
        margin: 0 auto;
    }
    .certified {
        color: #24cd7b;
    }

</style>